import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsButtonModule, CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsAlertComponent } from './alert.component';

@NgModule({
    declarations: [CmpsAlertComponent],
    imports: [CmpsButtonModule, CmpsIconModule, CommonModule],
    exports: [CmpsAlertComponent],
})
export class CmpsAlertModule {}
